// extracted by mini-css-extract-plugin
export var button = "_nw-2";
export var card = "_nw-0";
export var closeButtonContainer = "_nw-3";
export var iconContainer = "_nw-1";